import { Loader2, Sparkles, Brain, Target, TrendingUp, Users, ShieldAlert, Lightbulb } from 'lucide-react';
import { Card } from "@/components/ui/card";

export function AnalysisLoading() {
  return (
    <Card className="bg-white/90 backdrop-blur-sm rounded-2xl shadow-lg shadow-slate-200/50 border border-slate-200/60 p-8">
      <div className="flex items-center gap-6">
        {/* Loading Animation */}
        <div className="relative flex-shrink-0">
          <div className="w-16 h-16 bg-gradient-to-r from-slate-800 via-slate-700 to-slate-800 rounded-2xl flex items-center justify-center shadow-lg shadow-slate-900/25">
            <Loader2 className="h-6 w-6 text-white animate-spin" />
          </div>
          <div className="absolute -top-1 -right-1 w-5 h-5 bg-amber-400 rounded-full flex items-center justify-center shadow-md animate-pulse">
            <Sparkles className="h-2.5 w-2.5 text-amber-800" />
          </div>
        </div>

        {/* Content */}
        <div className="flex-1 min-w-0">
          <h3 className="text-xl font-bold text-slate-900 mb-2 flex items-center gap-2">
            Analyzing Resume
          </h3>
          <p className="text-slate-600 mb-4">
            Our advanced AI is analyzing the resume against job requirements to provide comprehensive insights.
          </p>
          
          {/* What's Being Analyzed */}
          <div className="grid grid-cols-2 md:grid-cols-3 gap-3 text-xs">
            <div className="flex items-center gap-2 text-slate-600">
              <Target className="h-3 w-3 text-blue-600 flex-shrink-0" />
              <span>Skills Assessment</span>
            </div>
            <div className="flex items-center gap-2 text-slate-600">
              <TrendingUp className="h-3 w-3 text-green-600 flex-shrink-0" />
              <span>Growth Potential</span>
            </div>
            <div className="flex items-center gap-2 text-slate-600">
              <ShieldAlert className="h-3 w-3 text-orange-600 flex-shrink-0" />
              <span>Risk Factors</span>
            </div>
            <div className="flex items-center gap-2 text-slate-600">
              <Users className="h-3 w-3 text-purple-600 flex-shrink-0" />
              <span>Interview Plan</span>
            </div>
            <div className="flex items-center gap-2 text-slate-600">
              <Lightbulb className="h-3 w-3 text-indigo-600 flex-shrink-0" />
              <span>Recommendations</span>
            </div>
            <div className="flex items-center gap-2 text-slate-600">
              <Brain className="h-3 w-3 text-teal-600 flex-shrink-0" />
              <span>Fit Score</span>
            </div>
          </div>
        </div>
      </div>

      {/* Subtle indicator */}
      <div className="mt-6 flex items-center justify-center">
        <div className="flex gap-1">
          <div className="w-2 h-2 bg-slate-400 rounded-full animate-pulse" style={{ animationDelay: '0ms' }}></div>
          <div className="w-2 h-2 bg-slate-400 rounded-full animate-pulse" style={{ animationDelay: '150ms' }}></div>
          <div className="w-2 h-2 bg-slate-400 rounded-full animate-pulse" style={{ animationDelay: '300ms' }}></div>
        </div>
        <span className="ml-3 text-xs text-slate-500">Processing with advanced AI models</span>
      </div>
    </Card>
  );
} 